module.exports = __webpack_public_path__ + "img/business@2x.1e6fb8b1.png";